import type { HTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

/**
 * Carte de contenu — surface, rayon et ombre du design system.
 *
 * `CardHeader`, `CardTitle` et `CardContent` ont été retirés : aucun écran
 * ne les importait, et le rôle de `CardTitle` (petit label en capitales)
 * est désormais tenu par `<SectionLabel>`, qui l'unifie avec les 110 autres
 * labels du produit.
 */
export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'rounded-[var(--radius-card)] border border-hair bg-surface shadow-[var(--shadow-card)]',
        className,
      )}
      {...props}
    />
  );
}
